import { render, staticRenderFns } from "./emails.vue?vue&type=template&id=ee1c41fa&scoped=true&"
import script from "./emails.vue?vue&type=script&lang=js&"
export * from "./emails.vue?vue&type=script&lang=js&"
import style0 from "./emails.vue?vue&type=style&index=0&id=ee1c41fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1c41fa",
  null
  
)

export default component.exports